// src/components/fallbacks.js

// All files currently in public/headline-pool
const HEADLINE_FILES = [
  'Power.jpg',
  'MA012RAW.jpg',
  'Guberhaus020.jpg',
  'diana3.jpg',
  'Devotion.jpg',
  'cher.jpg',
  'barbra.jpg',
  '2023Mixxxransitionscopy.jpg',
  '2023MixxxOdysseycopy.jpg',
  '2023MixxxExplorationcopy.jpg',
  '2023MixxxComplexitycopy.jpg',
  '2022Mixxx1opy.jpg',

  // Real-style numbered photos
  '14.jpg',
  '13.jpg',
  '12.jpg',
  '11.jpg',
  '10.jpg',
  '09.jpg',
  '08.jpg',
  '07.jpg',
  '06.jpg',
  '05.jpg',
  '04.jpg',
  '03.jpg',
  '02.jpg',
  '01.jpg',
];

const IS_MINE = (name) =>
  name.toLowerCase().includes('mixx') ||
  name.toLowerCase().includes('power') ||
  name.toLowerCase().includes('guberhaus') ||
  name.toLowerCase().includes('devotion') ||
  name.toLowerCase().includes('diana') ||
  name.toLowerCase().includes('cher') ||
  name.toLowerCase().includes('barbra');

const baseUrls = HEADLINE_FILES.map(
  (f) => `${process.env.PUBLIC_URL}/headline-pool/${f}`
);

// ✅ Clean split pools
export const ART_PHOTO_POOL = baseUrls.filter((url) =>
  IS_MINE(url.split('/').pop())
);

export const REAL_PHOTO_POOL = baseUrls.filter(
  (url) => !IS_MINE(url.split('/').pop())
);

// Keep legacy export so nothing else breaks
export const DEFAULT_PHOTO_POOL = [...ART_PHOTO_POOL, ...REAL_PHOTO_POOL];

// Shuffle helper
export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
export function pickFallback(i = 0) {
  if (!DEFAULT_PHOTO_POOL.length) return '';
  return DEFAULT_PHOTO_POOL[i % DEFAULT_PHOTO_POOL.length];
}
